import styled from '@emotion/styled';
import { ComponentProps } from 'react';

import { Colors } from '../../../styles/variables/colors';

const { error } = Colors;

const profilePrimary = 'var(--profile-primary, #6025D8)';
const profilePrimaryDark = 'var(--profile-primary-dark, #4c1dab)';
const profilePrimaryMuted = 'var(--profile-primary-muted, rgba(96, 37, 216, 0.1))';
const profileOnPrimary = 'var(--profile-on-primary, #ffffff)';

export const ToggleBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    min-width: 0;
`;

export const ButtonGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    width: 100%;
`;

const ToggleButtonLabelStyled = styled.span`
    color: #64748b;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.02em;
`;

export const ToggleButtonLabel = (props: ComponentProps<typeof ToggleButtonLabelStyled>) => (
    <ToggleButtonLabelStyled data-form-toggle-label="" {...props} />
);

export const ToggleButtonGroup = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: auto;
    max-width: 100%;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
`;

export const ToggleButton = styled.button<{ $selected?: boolean }>`
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    height: 28px;
    padding: 0 10px;
    border: none;
    border-right: 1px solid #e2e8f0;
    background: ${({ $selected }) => ($selected ? profilePrimary : '#ffffff')};
    color: ${({ $selected }) => ($selected ? profileOnPrimary : '#334155')};
    font: inherit;
    font-size: 12px;
    font-weight: ${({ $selected }) => ($selected ? 600 : 500)};
    line-height: 1;
    cursor: pointer;

    &:last-of-type {
        border-right: none;
    }

    &:hover:not(:disabled) {
        background: ${({ $selected }) => ($selected ? profilePrimaryDark : profilePrimaryMuted)};
        color: ${({ $selected }) => ($selected ? profileOnPrimary : profilePrimary)};
    }

    &:focus-visible {
        outline: 2px solid ${profilePrimary};
        outline-offset: -2px;
        z-index: 1;
    }
`;

export const ToggleValidationError = styled.p`
    margin: 0;
    min-height: 16px;
    color: ${error};
    font-size: 12px;
    line-height: 16px;
`;
